import Modal from "../Modal/Modal";
import Cookies from "universal-cookie";
import InventoryItem from "../../../../utils/game/mechanics/InventoryItem";
import InventoryItemDynamicCollection from "../../../../pages/character/components/InventoryItemCollection/InventoryItemDynamicCollection";
import Spinner from "../../system/Spinner/Spinner";
import { useEffect, useState } from "react";
import { useGetItemBankItemList } from "../../../../net/ItemBankManagement";

import "./ItemBankModal_style.css";

type Props = {
    isVisible?: boolean;
    onClose?: () => void;
};

function ItemBankModalContent(props: Props): JSX.Element {
    const [loadItemBankItemList, isLoadingItemBankItemList] =
        useGetItemBankItemList();
    const [itemList, setItemList] = useState<Array<InventoryItem>>([]);

    const cookies = new Cookies();

    useEffect(() => {
        loadItemBankItemList({
            variables: { token: cookies.get("session_token") },
            onComplete: (result) => {
                setItemList(result.sort((a, b) => a.title.localeCompare(b.title)));
            },
            onError: (error) => {},
        });
    }, []);

    return (
        <>
            {isLoadingItemBankItemList() ? (
                <Spinner />
            ) : (
                <InventoryItemDynamicCollection
                    id="ItemBankInventory"
                    items={itemList}
                    expanded={true}
                    contentAreaClassName="item-content-area"
                    isEditable={true}
                    itemRestrictor={(item) => item === null}
                    onItemChanged={(item) => {}}
                />
            )}
        </>
    );
}

export default function ItemBankModal(props: Props): JSX.Element {
    return (
        <Modal
            contentClassName="item-bank-modal"
            header="Item Bank"
            isVisible={props.isVisible}
            onClose={props.onClose}
        >
            <ItemBankModalContent />
        </Modal>
    );
}
